import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChart04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 20.7V7.9m6.4 12.8v-7.467m6.4 7.467V3.3m6.4 17.4V7.9"
    />
  </svg>
);
export default SvgBarChart04;
